import React, { useEffect, useState, useRef } from "react";
import { Toast } from "primereact/toast";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import { InputTextarea } from "primereact/inputtextarea";
import { Calendars } from "../../../components/Calendar/Calendar";
import { DialogConfirm, DialogDelete, DialogShow } from "../../../components/DialogService/DialogService";
import { FooterButtonCustomLabel, FooterButtonSigle } from "../../../components/FooterButton/FooterButton";
import { Loading } from "../../../components/Loading/Loading";
import { dataUserSession } from "../../../utilities/dataSession";
import { formatDateFile, formatDateAPI_V2, formatDateConvert } from "../../../utilities/DateUtil";
import { validateInputText } from "../../../utilities/ValidateUtil";
import { Dropdown } from "primereact/dropdown";

//PAGE
import P105Dialog from "./P105Dialog";
import P105DialogViewPic from "./P105DialogViewPic";
import P105List_1 from "./P105List_1";
import P105List_2 from "./P105List_2";

//SERVICE
import { pContractorReport1_Info, pContractorReport1_Update } from "../../../service/100/P105Service";
import { genPhotoList, genPhotoUpdate, genGetBranchInfo, genCiaCameraList } from "../../../service/GEN/GenService";
import { commonUpload } from "../../../service/APP/AppService";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { NullInt, NullString } from "../../../utilities/NullUtil";
import { deCodeBase64 } from "../../../components/UploadPic/UploadPicUtil";



import { ciaCameraNameInfo } from "../../../service/CIA/CiaService";
import PCIADialog from "../../CIA/PCIADialog.js";

export default function P105() {
    const toast = useRef(null);
    const history = useHistory();
    const [submitted, setSubmitted] = useState(false);
    const [deleteDialog, setDeleteDialog] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errData, setErrData] = useState(null);

    const [showDialog, setShowDialog] = useState(false);
    const [optionDialog, setOptionDialog] = useState({
        textShow: "",
        cancle: () => { },
    });
        //DropList กล้อง CIA
        const [ciaCameraList, setciaCameraList] = useState(null);
        const [ciaCameraListItem, setciaCameraListItem] = useState([]); 

    //Dialog
    const [confirmDialog, setConfirmDialog] = useState(false);
    const [dialogOption, setdialogOption] = useState({
        header: "",
        content: "",
        onConfirm: () => { },
        onCancle: () => { },
        footerBtn: () => { },
    });

    // date
    const [reportDtBegin, setReportDtBegin] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "09", "00"));
    const [reportDtEnd, setReportDtEnd] = useState(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate(), "16", "00"));

    //Pic
    const [dialogUpload, setDialogUpload] = useState({ dialog: false, show: false });
    const [dialogPic, setDialogPic] = useState({ dialog: false, pic: "", show: false });
    const [dataFile, setDataFile] = useState([]);

    // DATA
    const [formArray, setFormArray] = useState([]);
    const [dataTbImage, setDataTbImage] = useState([]);

    // SEARCH
    const [searchData, setSearchData] = useState({
        action: "",
        requestNo: "",
        userId: "",
        photoType: "",
    });

    const [countBtnSave, setCountBtnSave] = useState(0);

    const [ciaCameraId, setciaCameraId] = useState({ciaCameraId: ""});

    const [dialog, setDialog] = useState({
        open: false,
        action: "",
    });

    const [dataSet, setDataSet] = useState({});

    useEffect(() => {
        if (dataUserSession()) {
            if (history.location.state) {
                setSearchData({ ...history.location.state, userId: dataUserSession().userId, photoType: "C001" });
            } else {
                history.push("/100");
                // setSearchData({ requestNo: "R651600018", userId: dataUserSession().userId, photoType: "C001" });
            }
        } else {
            history.push("/login");
        }
    }, []);

    useEffect(() => {
        getDataContractorReport1_Info();
        getGenPhotoList();
        getCiaCameraList({ requestNo: searchData.requestNo });
    }, [searchData]);
    

    const getDataContractorReport1_Info = () => {
        setLoading(true);

        const req = {
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };
        pContractorReport1_Info(req).then(
            (res) => {
                setLoading(false);
                if (res !== undefined) {
                    let temp = [];
                    let index = 0;
                    if (res.length > 0) {
                        res.forEach((element) => {
                            temp.push({
                                ...element,
                                index: index,
                            });
                            index++;
                        });

                        if (temp[0].reportDtBegin !== null) setReportDtBegin(formatDateConvert(temp[0].reportDtBegin));
                        if (temp[0].reportDtEnd !== null) setReportDtEnd(formatDateConvert(temp[0].reportDtEnd));
                        if(temp[0].ciaCameraId != null) setciaCameraList(temp[0].ciaCameraId) ;

                        if(temp[0].ciaCameraId != null) setciaCameraId({ciaCameraId : temp[0].ciaCameraId}) ;

                        //setciaCameraId({ciaCameraId : "SSAA_585585_ECBDE"}) 
                        

                        setFormArray(temp);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const getGenPhotoList = () => {
        setDataTbImage([]);
        const req = {
            userId: searchData.userId,
            requestNo: searchData.requestNo,
            photoType: searchData.photoType,
        };
        genPhotoList(req).then(
            (res) => {
                setLoading(false);

                if (res !== undefined) {
                    let temp = [];
                    let index = 0;
                    if (res.data.length) {
                        res.data.forEach((element) => {
                            temp.push({
                                ...element,
                                index: index,
                            });
                            index++;
                        });
                        // setDataTbImage(temp);
                        //

                        if (dataTbImage.length > res.data.length) {
                            res.data.forEach((element1, index) => {
                                dataTbImage.forEach((element2) => {
                                    if (element1.photoSeq === element2.photoSeq) {
                                        temp[index].photoDesc = element2.photoDesc;
                                    }
                                });
                            });
                        } else {
                            dataTbImage.forEach((element, index) => {
                                if (element.photoSeq === temp[index].photoSeq) {
                                    temp[index].photoDesc = element.photoDesc;
                                }
                            });
                        }

                        setDataTbImage(temp);
                    }
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const footerButtonClose = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    setConfirmDialog({ open: false });
                }}
            />
        );
    };

    const footerButtonS = () => {
        return (
            <FooterButtonSigle
                btnLabel="ปิด"
                onClick={() => {
                    history.push("/100");
                    setConfirmDialog({ open: false });
                }}
            />
        );
    };

    const validation = () => {
        if (reportDtBegin === "" || reportDtEnd === "") {
            setSubmitted(true);
            return false;
        } else {
            setSubmitted(false);
            return true;
        }
    };

    const submitForm = (act) => {
        // Begin table 1
        if (!validation()) {
            return true;
        }
        setLoading(true);
        for (const iterator of formArray) {
            const req = {
                actionCode: act,
                caseNo: iterator.caseNo,
                remark: NullString(iterator.remark),
                reportQuantity: NullInt(iterator.caseQuantityReport),
                requestNo: iterator.requestNo,
                userId: searchData.userId,
                recordStamp: iterator.recordStamp,
                operateDtBegin: formatDateAPI_V2(reportDtBegin, true),
                operateDtEnd: formatDateAPI_V2(reportDtEnd, true),
                ciaCameraId: ciaCameraList,
            };
            pContractorReport1_Update(req).then(
                (res) => {
                    setLoading(false);
                    if (res.status === 200) {
                        if (act === "S") {
                            setdialogOption({
                                ...dialogOption,
                                header: "",
                                content: act === "S" ? "ส่งผู้คุมงานเรียบร้อยแล้ว" : alert.statusText,
                                footerBtn: () => footerButtonS(),
                            });
                            setConfirmDialog({ open: true });
                        } else {
                            if (res.data[0].statusText === "") {
                                if (res.data[0].statusCode === "C") {
                                    setdialogOption({
                                        ...dialogOption,
                                        header: "",
                                        content: "บันทึกข้อมูลสำเร็จ",
                                        footerBtn: () => footerButtonClose(),
                                    });
                                    setConfirmDialog({ open: true });
                                } else if (res.data[0].statusCode === "E") {
                                    setOptionDialog({
                                        ...optionDialog,
                                        textShow: `มีข้อผิดพลาด`,
                                        cancle: () => {
                                            setShowDialog(false);
                                        },
                                    });
                                }
                            } else {
                                setdialogOption({
                                    ...dialogOption,
                                    header: "",
                                    content: res.data[0].statusText,
                                    footerBtn: () => footerButtonClose(),
                                });
                                setConfirmDialog({ open: true });
                            }
                        }
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }

        // End table 1

        //Begin Table 2
        if (act === "U") {
            handlerGenPhotoUpdate("U");
        }
        // End Table 2
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    const setValForm = (_key) => {
        if (formArray.length > 0) return formArray[0][_key];
    };

    const handlerInpusText = (e, rowData, inputname) => {
        const val = e || "";

        const newList = [...formArray];
        const editIndex = newList.findIndex((item) => {
            return item.index === rowData.index;
        });

        if (editIndex > -1) {
            let newData = newList[editIndex];
            newData = {
                ...newData,
                [`${inputname}`]: val,
            };

            newList[editIndex] = newData;

            setFormArray(newList);
        }
    };
    const onInputTextChange = (val, rowData, key) => {
        const newList = [...dataTbImage];
        const editIndex = newList.findIndex((item) => item.index === rowData.index);
        if (editIndex > -1) {
            let newData = newList[editIndex];
            newData = {
                ...newData,
                [`${key}`]: val,
            };

            newList[editIndex] = newData;
            setDataTbImage(newList);
        }
    };

    const handlerGenPhotoUpdate = (act, path) => {
        const updatePhoto = (req) => {
            genPhotoUpdate(req).then(
                (res) => {
                    setLoading(false);
                    getGenPhotoList();
                    // console.log("handlerGenPhotoUpdate");
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        };

        if (act === "D") {
            const req = {
                actionCode: act,
                originalId: deleteDialog.data.originalId,
                photoDesc: deleteDialog.data.photoDesc,
                photoPath: deleteDialog.data.photoPath,
                photoSeq: deleteDialog.data.photoSeq,
                photoType: "C001",
                requestNo: searchData.requestNo,
                thumbnailPath: deleteDialog.data.thumbnailPath,
                userId: searchData.userId,
            };
            updatePhoto(req);
        } else if (act === "U") {
            for (const iterator of dataTbImage) {
                const req = {
                    actionCode: act,
                    originalId: iterator.originalId,
                    photoDesc: iterator.photoDesc,
                    photoPath: iterator.photoPath,
                    photoSeq: iterator.photoSeq,
                    photoType: "C001",
                    requestNo: searchData.requestNo,
                    thumbnailPath: iterator.thumbnailPath === null ? "" : iterator.thumbnailPath,
                    userId: searchData.userId,
                };
                setTimeout(() => {
                    updatePhoto(req);
                }, 2000);
            }
        } else if (act === "A") {
            const req = {
                actionCode: act,
                originalId: "0.0.0.0",
                photoDesc: "",
                photoPath: path,
                photoSeq: 0,
                photoType: "C001",
                requestNo: searchData.requestNo,
                thumbnailPath: "",
                userId: searchData.userId,
            };
            updatePhoto(req);
        }
    };

    const footerButton = () => {
        const handlerDeleteData = () => {
            handlerGenPhotoUpdate("D");
            setDeleteDialog(false);
        };

        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => handlerDeleteData()} onClickCancle={() => setDeleteDialog(false)} />;
    };

    const handlerOnSavePic = () => {
        for (let i = 0; i < dataFile.length; i++) {
            const req = {
                orderNo: "",
                requestNo: setValForm("requestNo"),
                userId: searchData.userId,
            };

            genGetBranchInfo(req).then(
                (res) => {
                    setLoading(false);
                    if (res !== undefined) {
                        onUploadPic(res[0], i);
                    } else {
                        showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
        setDialogUpload({ dialog: false, show: false });
    };

    const onUploadPic = (obj, i) => {
        setLoading(true);
        const req = {
            base64Pic: deCodeBase64(dataFile[i].fileUpload),
            branchId: obj.branchCode,
            fiscalYear: obj.fiscalYear,
            orderNo: "",
            picName: formatDateFile(new Date(), true) + "_" + i + "_" + setValForm("requestNo"),
            requestNo: setValForm("requestNo"),
            userId: searchData.userId,
            picType: dataFile[i].fileUpload.typefile,
        };

        commonUpload(req).then(
            (res) => {
                setLoading(false);
                handlerGenPhotoUpdate("A", res.picPath);
                const old = dataFile[i];
                const modifly = { ...old, picPath: res.picPath, picUrl: res.picUrl };
                setDataFile(modifly);

                if (res !== undefined) {
                } else {
                    showMessages("error", "เกิดข้อผิดพลาด", "บันทึกข้อมูลการรายงานผลผิดพลาด");
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const footerButtonCon = (act) => {
        return <FooterButtonCustomLabel labelCon="ยืนยัน" lableCan="ยกเลิก" onClickOk={() => submitForm(act)} onClickCancle={() => setConfirmDialog(false)} />;
    };

    const handlerSettingDialogConfirm = (key) => {
        switch (key) {
            case "S":
                setdialogOption({
                    ...dialogOption,
                    header: "",
                    content: "ต้องการส่งข้อมูลให้ผู้คุมงานหรือไม่",
                    footerBtn: () => footerButtonCon("S"),
                    onCancle: () => setConfirmDialog(false),
                });
                break;
            case "SAVE":
                setdialogOption({
                    ...dialogOption,
                    header: "",
                    content: "คุณต้องการบันทึกข้อมูลหรือไม่",
                    footerBtn: () => footerButtonCon("U"),
                    onCancle: () => setConfirmDialog(false),
                });
                break;
            default:
                break;
        }
        setConfirmDialog({ open: true });
    };

    const viewImage = (event) => {
        setDialogPic({
            dialog: true,
            show: true,
            pic: event.photoPath,
        });
    };

    const handlerDisplayMode = () => {
        // return false;
        return setValForm("displayMode") === "Y" ? true : false;
    };

    const disBtnSave = () => {
        // return false;

        return setValForm("displayMode") === "Y" || countBtnSave !== 0 ? true : false;
    };

    const disButton = () => {
        // return false;

        if (setValForm("displayMode") === "Y") {
            return true;
        } else {
            if (countBtnSave !== 0) {
                return false;
            } else {
                return true;
            }
        }
    };

    const getCiaCameraList = (data) => {
        const req = {
            requestNo: data.requestNo,
            userId: dataUserSession().userId,
        };
        genCiaCameraList(req).then((res) => {
            setLoading(false);
            if (res.status === 200) {
                let arr = [];
                res.data.map((item, index) => {
                    arr.push({
                        ...item,
                    });
                });
                setciaCameraListItem(arr);
            } else {
                showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
            }

        },
            function (err) {
                setLoading(false);
                setErrData(err);
            })
    };


    const onOpenDialog = () => {
        onGetDataInfo(ciaCameraId);
        
    }


    const onGetDataInfo = async (data) => {
        setLoading(true);
        console.log("ciaCameraId we: ", data)
   
            let req = {
                cameraCode : data.ciaCameraId,
                userId: dataUserSession().userId,
            };
    
            await ciaCameraNameInfo(req).then(
                (res) => {
                    setLoading(false);
                    console.log("dataList : ", res.data)
                    if (res.data !== null) {
                        

                        setDialog({ open: true , action: "U"});
                        setDataSet(res.data);
                       
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด `, `ไม่พบข้อมูล`);
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
       
    };

    return (
        <>
            <Loading loading={loading} />
            <ValidateService err={errData} setErr={setErrData} />
            <div className="p-grid crud-demo">
                <Toast ref={toast} position="top-right" />
                <div className="p-col-12">
                    <div className="card">
                        <div className="p-fluid p-formgrid p-grid">

                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">เลขที่ใบแจ้งฯ</label>
                                <InputText id="requestNo" type="text" disabled={true} maxLength="20" value={setValForm("requestNo")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestType">ประเภทงาน</label>
                                <InputText id="requestType" type="text" disabled={true} maxLength="100" value={setValForm("requestType")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">

                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="contractNo">เลขที่สัญญา</label>
                                <InputText id="contractNo" type="text" disabled={true} maxLength="20" value={setValForm("contractNo")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="routeName">เส้นทาง</label>
                                <InputText id="routeName" type="text" disabled={true} maxLength="200" value={setValForm("routeName")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                            <label htmlFor="routeNo">กล้อง CIA</label>
                            <Dropdown
                                    id="ciaCameraId"
                                   // className={submitted && !formObject.ciaCameraId ? "p-invalid" : ""}
                                    value={ciaCameraList}
                                    optionValue="cameraId"
                                    onChange={(e) => {
                                        setciaCameraList(e.value);
                                    }}
                                    options={ciaCameraListItem}
                                    optionLabel="cameraName"
                                    placeholder="เลือก กล้อง CIA"
                                   
                                    maxLength="5"
                                ></Dropdown>
                            </div>
                        </div>
                        <hr />
                        <br />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationBegin">บริเวณก่อสร้าง</label>
                                <InputText id="locationBegin" type="text" disabled={true} maxLength="20" value={setValForm("locationBegin")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="locationEnd">ถึง</label>
                                <InputText id="locationEnd" type="text" disabled={true} maxLength="20" value={setValForm("locationEnd")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeBegin">วันที่เวลาขอออกปฏิบัติงานจาก</label>
                                <InputText id="operateTimeBegin" type="text" disabled={true} maxLength="10" value={setValForm("operateTimeBegin")} />
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="operateTimeEnd">วันที่เวลาขอออกปฏิบัติงานถึง</label>
                                <InputText id="operateTimeEnd" type="text" disabled={true} maxLength="10" value={setValForm("operateTimeEnd")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-2"></div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="foremanName">หัวหน้างาน</label>
                                <InputText id="foremanName" type="text" disabled={true} maxLength="10" value={setValForm("foremanName")} />
                            </div>
                        </div>
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDtBegin">วันที่เวลาออกปฏิบัติงานจาก</label>
                                <span style={{ color: "red" }}>*</span>
                                <Calendars key="reportDtBegin" id="reportDtBegin" value={new Date(reportDtBegin)} onChange={(e) => setReportDtBegin(e.target.value)} disabled={handlerDisplayMode()} showTime={true} />
                                {submitted && !reportDtBegin && validateInputText("reportDtBegin", "วันที่เวลาออกปฏิบัติงานจาก")}
                            </div>
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="reportDtEnd">วันที่เวลาออกปฏิบัติงานถึง</label>
                                <span style={{ color: "red" }}>*</span>
                                <Calendars key="reportDtEnd" id="reportDtEnd" value={new Date(reportDtEnd)} onChange={(e) => setReportDtEnd(e.target.value)} disabled={handlerDisplayMode()} showTime={true} />
                                {submitted && !reportDtEnd && validateInputText("reportDtEnd", "วันที่เวลาออกปฏิบัติงานถึง")}
                            </div>
                        </div>
                        <br />
                        <P105List_1 dataTable={formArray} inpusText={handlerInpusText} />
                        <label>รูปถ่าย</label>
                        <hr />
                        <br />
                        <P105List_2 dataTable={dataTbImage} setDeleteDialog={setDeleteDialog} setheadlerInpusText={onInputTextChange} dialogUploadPic={setDialogUpload} viewImage={viewImage} displayMode={handlerDisplayMode} />
                        <br />
                        <div className="p-fluid p-formgrid p-grid">
                            <div className="p-field p-col-12 p-md-4">
                                <label htmlFor="requestNo">เหตุผลจากผู้ควบคุมงาน</label>
                                <InputTextarea id="supervisorReason" value={setValForm("supervisorReason")} rows="4" disabled={true} />
                            </div>
                        </div>
                        <div className="p-grid" style={{ textAlign: "center" }}>
                            <div className="p-col-12">
                                <div className="p-grid" style={{ textAlign: "center" }}>
                                    <div className="p-col-2"></div>
                                    <div className="p-col-4">
                                        <Button
                                            className="p-button-success p-button p-mr-2 p-mb-2"
                                            icon="pi pi-save"
                                            label="บันทึก"
                                            style={{ width: 170 }}
                                            onClick={() => {
                                                submitForm("U");
                                                setCountBtnSave(1);
                                            }}
                                            disabled={disBtnSave()}
                                        />
                                        <Button
                                            className="p-button-secondary p-button p-mr-2 p-mb-2"
                                            icon="pi pi-arrow-left"
                                            label="กลับหน้าจอหลัก"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px" }}
                                            onClick={() => history.push("/100")}
                                        />
                                    </div>
                                    <div className="p-col-4">
                                        <Button
                                            className="p-button-warning p-button p-mr-2 p-mb-2"
                                            icon="pi pi-sign-in"
                                            label="ส่งผู้คุมงาน"
                                            // style={{ marginLeft: '5px' }}
                                            style={{ width: 170, marginLeft: "5px" }}
                                            onClick={() => handlerSettingDialogConfirm("S")}
                                            disabled={disButton()}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <P105Dialog dialog={dialogUpload} setDialog={setDialogUpload} dataFile={dataFile} setDataFile={setDataFile} typeFile=".jpg" onSaveFile={handlerOnSavePic} onOpenDialog={onOpenDialog} />

                    <DialogDelete visible={deleteDialog.open} header="การยืนยัน" modal footer={footerButton()} onHide={() => setDeleteDialog(false)}  textContent="คุณต้องการลบข้อมูล ใช่หรือไม่ ?" />
                    <DialogConfirm visible={confirmDialog.open} header={dialogOption.header} modal footer={dialogOption.footerBtn} onHide={() => setConfirmDialog(false)} textContent={dialogOption.content} />

                    <DialogShow visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={optionDialog.textShow} btnCancle={optionDialog.cancle} />
                    <P105DialogViewPic dialog={dialogPic} data={dialogPic.pic} modal setDialogPic={setDialogPic} />
                    <PCIADialog dialog={dialog} setDialog={setDialog} dataSet={dataSet}></PCIADialog>
                </div>
            </div>
        </>
    );
}
